<section
    *ngIf="estimateMeasurement && measurementForm"
    class="estimate-measurement-container mb-2"
    [ngClass]="{ selected: estimateMeasurement.isSelected }">
    <a
        *ngIf="!states.isEstimateReadonly"
        class="grip-container"
        cdkDragHandle
        (mousedown)="toggleDrag(true)"
        (touchstart)="toggleDrag(true)"
        (mouseleave)="toggleDrag(false)"
        (touchend)="toggleDrag(false)">
        <span class="grip"></span>
    </a>
    <span class="order mr-2" [ngClass]="states.isEstimateReadonly ? 'ml-2' : ''">{{ order }}</span>
    <div class="condensed-col description" [ngClass]="{ invalid: isInvalidMeasurement }">
        <input
            legacy-css
            #measurementDescription
            type="text"
            class="form-control"
            [formControl]="$any(measurementForm.controls.description)" />
        <i *ngIf="isInvalidMeasurement" class="fa fa-exclamation-circle"></i>
    </div>

    <div class="condensed-col quantity">
        <input
            legacy-css
            *ngIf="
                !viewSettings.isOverLayer || !estimateMeasurementStoresService.isSlowMode || !estimateMeasurement.isInTakeOff;
                else slowModeTag
            "
            [name]="'Measurement' + estimateMeasurement.order"
            [readonly]="!states.canChangeMeasurements || states.isEstimateReadonly"
            type="text"
            class="form-control text-right"
            [(ngModel)]="displayedquantity"
            appNumeric
            [min]="0"
            [decimals]="3"
            required
            [imperial]="isImperial"
            #quantity
            (focus)="quantity.select()"
            (change)="onquantityChanged(quantity.value)" />

        <ng-template #slowModeTag>
            <input legacy-css type="text" class="form-control text-right" value="In progress..." readonly />
        </ng-template>
    </div>

    <div class="condensed-col uom">
        <select legacy-css class="form-control" [formControl]="$any(measurementForm.controls.uom)">
            <option [value]="unit" *ngFor="let unit of supportedUnits">{{ unit }}</option>
        </select>
    </div>

    <app-estimate-measurement-item-actions
        [estimateMeasurement]="estimateMeasurement"
        [hasPlans]="hasPlans"
        [states]="states"
        [viewSettings]="viewSettings"
        (takeOffsChanges)="onTakeOffs()"
        (calculateChanges)="onCalculate()"
        (toggleMeasurementChanges)="toggleMeasurement($event)"
        (deleteChanges)="onDeleteMeasurement()">
    </app-estimate-measurement-item-actions>
</section>
